import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ConnectAccount from './ConnectAccount'
import WithdrawMoney from './WithdrawMoney'
import Amount from './Amount'
import Review from './Review'
import Success from './Success'

const Withdraw = () => {
    return (
        <div>
            <Routes>
                <Route path="/connect-account" element={<ConnectAccount />} />
                <Route path="/account" element={<WithdrawMoney />} />
                <Route path="/amount" element={<Amount />} />
                <Route path="/review" element={<Review />} />
                <Route path="/success" element={<Success />} />
            </Routes>
        </div>
    )
}

export default Withdraw